<c-form-field [control]="control" [showErrors]="showError">
  @if (label) {
    <ion-label class="input__label">{{ label }}</ion-label>
  }

  <div class="input__box" cFieldBox>
    @if (icon && iconStart) {
      <c-icon class="input__icon" [icon]="icon" [color]="iconColor" />
    }

    <ion-input
      #input
      class="input__field"
      [type]="type"
      [inputmode]="inputMode"
      placeholder="{{ placeholder | transloco }}"
      [formControl]="control"
      [maxlength]="maxLength"
      [minlength]="minLength"
      [clearInput]="clearInput"
      [maskito]="maskito"
      [maskitoElement]="maskPredicate" />

    @if (icon && !iconStart) {
      <c-icon class="input__icon" [icon]="icon" [color]="iconColor" />
    }
  </div>

  <c-field-message [helpText]="helpText" />
</c-form-field>
